export default __webpack_public_path__ + "static/media/11-EXT-(3-5).64c6dc2c.jpg";